var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomText', {
    staticClass: "swatch-tabs_icon icon",
    attrs: {
      "elementType": "span",
      "customClass": _vm.$props.customClass
    }
  }, [_vm.$props.useImgIcon ? _c('template', {
    slot: "child"
  }, [_c('CustomImage', {
    attrs: {
      "src": _vm.customsAssets + '/' + _vm.icon
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }